import React, { useEffect } from 'react';

const SmartFAQ: React.FC = () => {
  const smartFAQTagId = 'smartFAQTagId';

  useEffect(() => {
    if (document.getElementById(smartFAQTagId) !== null)
      return;

    const scriptElementHumany = document.createElement('script');
    scriptElementHumany.id = smartFAQTagId;
    scriptElementHumany.type = 'text/javascript';
    scriptElementHumany.text = `
      const anchorElementHumany = document.createElement("a");
      anchorElementHumany.hidden = "hidden";
      anchorElementHumany.href = "//folksam.humany.net/kpa-smart-faq";
      document.body.appendChild(anchorElementHumany);
      (function(a, b, c, d, e, f, g) {
      for (var h, i = /[?&]{1}(humany[^=]*)=([^&#]*)/g; h = i.exec(a.location.search);) {
        c += (-1 < c.indexOf("?") ? "&" : "?") + h[1] + "=" + h[2];
      }
      f = b.createElement(e);
      f.async = true;
      f.src = c;
      g = b.getElementsByTagName(e)[0];
      g.parentNode.insertBefore(f, g);
      a[d] = a[d] || {
        _c: [],
        configure: function() {
            a[d]._c.push(arguments);
        }
      };
      var j = d.toLowerCase();
      a[j] = a[j] || {
        _c: [],
        configure: function() {
            a[j]._c.push(arguments);
        }
      };
      })(window, document, "//folksam.humany.net/kpa-floating/embed.js", "Humany", "script");`;
    document.body.appendChild(scriptElementHumany);
  }, []);

  return <></>;
};

export default SmartFAQ;
